import type {RouteRecordRaw} from "vue-router";

export const requisicaoCompraRoutes: RouteRecordRaw[] = [
    {
        path: "/requisicao-compra",
        name: "requisicao-compra",
        meta: {authRequired: true},
        component: () => import("@/modules/requisicaoCompra/pages/PageRequisicaoCompra.vue")
    },
];
